import React from 'react'
import clsx from 'clsx'
import styles from './UIGamecityImprovementTrackerSquare.module.scss'
import {CityImprovementTypes} from '@colonist/game-states'

export interface UIGameCityImprovementTrackerSquareProps {
    cityImprovementType: CityImprovementTypes
    active: boolean
    className?: string
}
export function UIGameCityImprovementTrackerSquare({
    cityImprovementType,
    active,
    className,
}: UIGameCityImprovementTrackerSquareProps) {
    const cityImprovementTypeText = CityImprovementTypes[cityImprovementType].toLowerCase()
    return <div className={clsx(styles.squareContainer, className)}>
        <div className={styles.border} />
        <div className={clsx(styles.background, styles[cityImprovementTypeText], {[styles.inactive]: !active})} />
    </div>
}
